import type { ImageView } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { cn, ImageWithFallback } from '@/shared/ui';

interface PortfolioThumbnailProps {
  readonly image: ImageView;
  readonly title: string;
  readonly number: number;
  readonly selected: boolean;
  readonly onSelect: () => void;
}

export const PortfolioThumbnail = ({
  image,
  title,
  number,
  selected,
  onSelect,
}: PortfolioThumbnailProps): ReactElement => (
  <button
    type="button"
    aria-label={`${title} 사진 ${number}`}
    aria-pressed={selected}
    onClick={onSelect}
    className={cn(
      'aspect-[4/3] w-20 shrink-0 cursor-pointer overflow-hidden border-b-2 bg-muted/70 transition-opacity focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring sm:w-28',
      selected
        ? 'border-foreground opacity-100'
        : 'border-transparent opacity-60 hover:opacity-100',
    )}
  >
    <ImageWithFallback
      key={image.thumbnailUrl}
      src={image.thumbnailUrl}
      alt={`${title} 썸네일 ${number}`}
      loading="eager"
      className="size-full object-cover"
    />
  </button>
);
